import { Injectable } from '@angular/core';

/**
 * Service to track invalid branch errors for showing dialogs after redirect
 */
@Injectable({
    providedIn: 'root',
})
export class BranchErrorService {
    private _invalidBranchName: string | null = null;

    /** Store the invalid branch name to show dialog after redirect */
    setInvalidBranch(branchName: string): void {
        this._invalidBranchName = branchName;
    }

    /** Get and clear the invalid branch name (one-time read) */
    getAndClearInvalidBranch(): string | null {
        const branch = this._invalidBranchName;
        this._invalidBranchName = null;
        return branch;
    }

    /** Check if there's a pending invalid branch error */
    hasInvalidBranch(): boolean {
        return this._invalidBranchName !== null;
    }
}
